<template>
  <div class="mobile_container">
    <div class="mobile_banner">

    </div>
  </div>
</template>

<script>
  import config from '@/config.js'

  export default {
    name: 'video',
    components: {},
    data() {
      return {
      }
    },
    mounted: function () {
    },
    methods: {
    }
  }
</script>


<style>

</style>



// WEBPACK FOOTER //
// src/components/mobile/video.vue